module.exports = __webpack_public_path__ + "static/media/arrow-down.f01d34c7.svg";